{
  "backLinkLabel": "Tilbake til eiendom",
  "pageTitle": "Legg til ny eiendom",
  "title": "Eiendommer",
  "description": "Legg til en eller flere eiendommer"
}
